function Badge({ children, variant = 'default', className = '' }) {
  const variantClass = variant !== 'default' ? `badge-${variant}` : ''
  const classes = ['badge', variantClass, className].filter(Boolean).join(' ')

  return (
    <span className={classes}>
      {children}
    </span>
  )
}

// Predefined badge variants for common statuses
Badge.Active = ({ children = 'Active' }) => <Badge variant="active">{children}</Badge>
Badge.Planning = ({ children = 'Planning' }) => <Badge variant="planning">{children}</Badge>
Badge.Paused = ({ children = 'Paused' }) => <Badge variant="paused">{children}</Badge>

export default Badge
